import { Component, computed, inject, input, LOCALE_ID, output } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { OrderListItem } from '../../../../../pages/admin-dashboard/orders-management/orders.model';
import { LoadState } from '../order-list-component';
import { Loading } from '../../../../../utils/loading/loading';
import { ErrorData } from '../../../../../utils/error-data/error-data';
import { EmptyData } from '../../../../../utils/empty-data/empty-data';

@Component({
  selector: 'app-orders-cards-list',
  standalone: true,
  imports: [DatePipe, DecimalPipe, Loading, ErrorData, EmptyData],
  templateUrl: './orders-cards-list.html',
  styleUrl: './orders-cards-list.scss',
})
export class OrdersCardsList {
  private locale = inject(LOCALE_ID);

  orders = input<OrderListItem[] | null>(null);
  isFiltersApplied = input<boolean>(false);
  currentPage = input<number>(1);
  totalPages = input<number>(1);

  state = input<LoadState>('loading');

  rowClick = output<number>();
  pageChange = output<number>();

  isArabic = computed(() => this.locale.startsWith('ar'));

  getStatusClass(statusTitleEn: string): string {
    const s = statusTitleEn.toLowerCase();

    if (s.includes('rejected') || s.includes('undelivered') || s.includes('مرفوض')) return 'bg-status-danger';

    if (
      s.includes('reviewed') ||
      s.includes('delivered') ||
      s.includes('completed') ||
      s.includes('active') ||
      s.includes('مفعّل') ||
      s.includes('مكتمل')
    )
      return 'bg-status-success';

    if (s.includes('pending') || s.includes('new') || s.includes('loaded')) return 'bg-status-warning';

    if (s.includes('printed') || s.includes('shipped') || s.includes('packaged') || s.includes('in progress'))
      return 'bg-status-info';

    return 'bg-status-neutral';
  }

  totalPagesArray() {
    return Array.from({ length: this.totalPages() }, (_, i) => i + 1);
  }
}
